import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyProduct from '../components/addEditCopyProduct.vue';

var CopyProductPage = function (_super) {
  __extends(CopyProductPage, _super);

  function CopyProductPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyProductPage = __decorate([Component({
    components: {
      AddEditCopyProduct: AddEditCopyProduct
    }
  })], CopyProductPage);
  return CopyProductPage;
}(Vue);

export default CopyProductPage;